import {
  Component,
  Input,
  Output,
  EventEmitter,  ChangeDetectionStrategy,

  Optional,
  Self,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ChangeDetectorRef
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CommonRadioData } from './common-radio.component.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wm-common-radio',
  standalone: false,
  templateUrl: './common-radio.component.html',
  styleUrls: ['./common-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonRadioComponent
  implements ControlValueAccessor, OnInit, OnDestroy {


    private _data: CommonRadioData;
  _value: string | number = '';
  private _valueSubscription?: Subscription;



  @Input({ required: true })
  set data(value: CommonRadioData) {
    this._data = { ...this._data, ...value,direction:'column' };
    if (value && value.value !== undefined) {
      this._value = value.value;
    }
    this.syncValueFromData();
  }

  get data(): CommonRadioData {
    return this._data;
  }


  @Output() valueChange = new EventEmitter<any>();


  onChange = (_: any) => {};
  onTouched = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl,    private cdr: ChangeDetectorRef
) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    // console.log('[Radio] init with data.value:', this._data.value);
    this.setupControlSubscription();
  }


  private syncValueFromData(): void {
    const incomingValue = this._data.value ?? null;

    if (this.ngControl?.control) {
      if (this.ngControl.control.value !== incomingValue) {
        this.ngControl.control.setValue(incomingValue, { emitEvent: false });
        this._value = incomingValue;
      }
    } else {
      this._value = incomingValue;
    }
  }

  /* ===== SYNC FROM FORMCONTROL ===== */

  private setupControlSubscription(): void {
    if (this.ngControl?.control) {

      if (
        (this.ngControl.control.value === null ||
         this.ngControl.control.value === '') &&
        this._data.value !== null
      ) {
        this.ngControl.control.setValue(this._data.value, { emitEvent: false });
        this._value = this._data.value;
      }

      this._valueSubscription =
        this.ngControl.control.valueChanges.subscribe(val => {
          const newValue = val ?? null;
          if (this._value !== newValue) {
            this._value = newValue;
            this.valueChange.emit(newValue);
          }
        });
    }
  }

  ngOnDestroy(): void {
    this._valueSubscription?.unsubscribe();
  }

  /* ===== CVA METHODS ===== */

  writeValue(value: any): void {
    this._value = value;
    this.cdr.markForCheck(); 

  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void {
    if (this.data) {
      this.data.disabled = isDisabled;
      this.cdr.markForCheck();
    }
  }

  onSelectionChange(value: any): void {
    // console.log('[Radio] user selected:', value);
    this._value = value;
    this.onChange(value);
    this.onTouched();
    this.valueChange.emit(value);
  }

  get selectedValue(): any {
    return this._value;
  }

  get hasValidationError(): boolean {
    const control = this.ngControl?.control;

    // Added on 17-04-2026 by amisha to show a required message for permit-form radios
    // from the radio component itself, without affecting checkbox behavior.
    return !!(
      control &&
      this.data?.required &&
      control.errors?.required &&
      (control.touched || control.dirty)
    );
  }
}
